import { render, staticRenderFns } from "./ParticipantApproval.vue?vue&type=template&id=2686af74"
import script from "./ParticipantApproval.vue?vue&type=script&lang=js"
export * from "./ParticipantApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports